module.exports = __webpack_public_path__ + "img/luminance_band.68195ae3.png";